import axios from "axios";
import TokenService from "@/data/services/token.service";

const instance = axios.create({
  baseURL: "https://api.classroom.concinnitylimited.com/api",
  headers: {
    "Authorization": `Bearer ${TokenService.getLocalAccessToken()}`,
    "Content-Type": "application/json",
  },
});
export default instance;
